import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  TextArea,
  Button,
  FormGroup,
  FormField,
  Input,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardRehabTreatmentPerformRecordUX = (props: any) => {
    return(
      <div
        id="CardRehabTreatmentPerformRecordUX-div-0"
        style={{margin: "0px 10px"}}>
        <div
          id="CardRehabTreatmentPerformRecordUX-div-71">
          
          <div
            id="CardRehabTreatmentPerformRecordUX-div-72"
            style={{fontWeight: "bold", margin: "1rem 0.25rem 0.5rem 0.25rem", fontSize: "1.15rem"}}>
            {props.languageUX === "en" ? "Treatment Performed today" : "การรักษาที่ดำเนินการในวันนี้"}
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-130"
            style={{display: "flex", alignItems: "center", marginBottom: "0.5rem"}}>
            
            <div
              id="CardRehabTreatmentPerformRecordUX-div-131"
              style={{fontWeight: "bold", marginLeft: "6px", marginRight: "12px"}}>
              {props.languageUX === "en" ? "Treatment Perform date" : "วันที่ดำเนินการรักษา"}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-132">
              {props.performStartDateTextBox}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-133"
              style={{fontWeight: "bold", marginLeft: "12px", marginRight: "12px"}}>
              {props.languageUX === "en" ? "to" : "ถึง"}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-134">
              {props.performEndDateTextBox}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-135"
              style={{marginLeft: "12px", marginRight: "12px"}}>
              {props.buttonSearch}
            </div>
            <Checkbox
              checked={props.isIncludePerformed}
              id="CardRehabTreatmentPerformRecordUX-Checkbox-136"
              label={props.languageUX === "en" ? "Include Performed" : "รวมที่ดำเนินการแล้ว"}
              onChange={props.onChangeIncludePerformedRecord}>
            </Checkbox>
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-73"
            style={{width: "100%"}}>
            
            <div
              id="CardRehabTreatmentPerformRecordUX-div-119">
              {props.treatmentPerform}
            </div>
          </div>
        </div>
        <div
          id="CardRehabTreatmentPerformRecordUX-div-62"
          style={{margin: "2rem 0 1rem", display: props.data? "":"none"}}>
          
          <div
            id="CardRehabTreatmentPerformRecordUX-div-1"
            style={{display:"flex", justifyContent:"space-between"}}>
            
            <div
              id="CardRehabTreatmentPerformRecordUX-div-67"
              style={{fontSize: "1.15rem",fontWeight:"bold",textDecoration:"underline",margin:"6px 0px"}}>
              {props.languageUX === "en" ? "Examination" : "การตรวจสอบ"}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-68"
              style={{display: "flex"}}>
              
              <Button
                color="purple"
                icon={true}
                id="CardRehabTreatmentPerformRecordUX-Button-69"
                onClick={props.onOpenScanDocument}
                size="mini"
                style={{display: "flex", alignItems: "center"}}>
                
                <img
                  id="CardRehabTreatmentPerformRecordUX-img-75"
                  src="/static/images/rehab/scanning-document.png"
                  style={{width: "16px"}}>
                </img>
                <label
                  id="CardRehabTreatmentPerformRecordUX-label-76"
                  style={{marginLeft: "6px"}}>
                  {props.languageUX === "en" ? "Scanning Document" : "การสแกนเอกสาร"}
                </label>
              </Button>
              <Button
                color="orange"
                icon={true}
                id="CardRehabTreatmentPerformRecordUX-Button-70"
                onClick={props.onOpenViewDocument}
                size="mini"
                style={{display: "flex", alignItems: "center", position: "relative"}}>
                
                <img
                  id="CardRehabTreatmentPerformRecordUX-img-77"
                  src="/static/images/rehab/view-document.png"
                  style={{width: "21px", position: "absolute", "left": "8px", marginTop: "5px"}}>
                </img>
                <label
                  id="CardRehabTreatmentPerformRecordUX-label-78"
                  style={{marginLeft: "22px"}}>
                  {props.languageUX === "en" ? "View Document Scan" : "ดูเอกสาร สแกน"}
                </label>
              </Button>
            </div>
          </div>
        </div>
        <Form
          className={props.data? "":"hidden"}
          id="CardRehabTreatmentPerformRecordUX-Form-15">
          <FormGroup
            id="CardRehabTreatmentPerformRecordUX-FormGroup-79"
            inline={true}>
            <FormField
              id="CardRehabTreatmentPerformRecordUX-FormField-84"
              inline={true}
              style={{alignItems: "flex-start"}}
              width={16}>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-91"
                style={{width: "85px"}}>
                Subjective: 
              </label>
              <TextArea
                id="CardRehabTreatmentPerformRecordUX-TextArea-95"
                name="subjective"
                onChange={props.onChangeValue}
                value={props.data?.subjective ?? ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardRehabTreatmentPerformRecordUX-FormGroup-80"
            inline={true}>
            <FormField
              id="CardRehabTreatmentPerformRecordUX-FormField-85"
              inline={true}
              style={{alignItems: "flex-start"}}
              width={16}>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-90"
                style={{width: "85px"}}>
                Objective: 
              </label>
              <TextArea
                id="CardRehabTreatmentPerformRecordUX-TextArea-94"
                name="objective"
                onChange={props.onChangeValue}
                value={props.data?.objective?? ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardRehabTreatmentPerformRecordUX-FormGroup-82"
            inline={true}>
            <FormField
              id="CardRehabTreatmentPerformRecordUX-FormField-86"
              inline={true}
              style={{alignItems: "flex-start"}}
              width={16}>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-89"
                style={{width: "85px"}}>
                Assessment: 
              </label>
              <TextArea
                id="CardRehabTreatmentPerformRecordUX-TextArea-93"
                name="assessment"
                onChange={props.onChangeValue}
                value={props.data?.assessment?? ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardRehabTreatmentPerformRecordUX-FormGroup-83"
            inline={true}>
            <FormField
              id="CardRehabTreatmentPerformRecordUX-FormField-87"
              inline={true}
              style={{alignItems: "flex-start"}}
              width={16}>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-88"
                style={{width: "85px"}}>
                Goal: 
              </label>
              <TextArea
                id="CardRehabTreatmentPerformRecordUX-TextArea-92"
                name="goal"
                onChange={props.onChangeValue}
                value={props.data?.goal?? ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardRehabTreatmentPerformRecordUX-FormGroup-81">
            <FormField
              id="CardRehabTreatmentPerformRecordUX-FormField-96"
              width={16}>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-97">
                {props.languageUX === "en" ? "Other Examination :" : "การสอบอื่นๆ :"}
              </label>
              <TextArea
                id="CardRehabTreatmentPerformRecordUX-TextArea-98"
                name="other_examination"
                onChange={props.onChangeValue}
                rows={5}
                value={props.data?.other_examination?? ""}>
              </TextArea>
            </FormField>
          </FormGroup>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-66"
            style={{marginBottom: "2rem"}}>
            
            <div
              id="CardRehabTreatmentPerformRecordUX-div-21"
              style={{fontSize:"1.15rem",fontWeight:"bold",textDecoration:"underline",margin:"10px 0px 5px"}}>
              {props.languageUX === "en" ? "Procedure code" : "รหัสขั้นตอน"}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-35"
              style={{display:"flex",alignItems:"center", marginLeft: "1.25rem"}}>
              
              <div
                id="CardRehabTreatmentPerformRecordUX-div-44"
                style={{width:"160px"}}>
                Principle procedure: 
              </div>
              <div
                id="CardRehabTreatmentPerformRecordUX-div-120">
                {props.principalProcedure}
              </div>
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-48">
              {props.buttonAddSecondary}
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-43"
              style={{display:props.data?.procedure?.secondary?.length === 0 ? "none":"flex", marginLeft: "1.25rem"}}>
              
              <div
                id="CardRehabTreatmentPerformRecordUX-div-45"
                style={{width:"160px", marginTop: "7px"}}>
                Secondary procedure: 
              </div>
              <div
                id="CardRehabTreatmentPerformRecordUX-div-121">
                {props.secondaryProcedure}
              </div>
            </div>
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-22"
            style={{fontWeight:"bold",fontSize: "1.15rem",margin:"10px 0px",textDecoration:"underline"}}>
            {props.languageUX === "en" ? "Treatment Details" : "รายละเอียดการรักษา"}
          </div>
          <div
            className="ui form"
            id="CardRehabTreatmentPerformRecordUX-div-23">
            
            <FormGroup
              id="CardRehabTreatmentPerformRecordUX-FormGroup-99"
              inline={true}
              widths={16}>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-101">
                <label
                  id="CardRehabTreatmentPerformRecordUX-label-108">
                  {props.languageUX === "en" ? "Start date/time :" : "วันที่/เวลาเริ่มต้น :"}
                </label>
              </FormField>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-103">
                <div
                  id="CardRehabTreatmentPerformRecordUX-div-110"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardRehabTreatmentPerformRecordUX-DateTextBox-112"
                    onChange={props.onChangeDate?.("startDate")}
                    value={props.data?.startDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-104"
                width={2}>
                <div
                  id="CardRehabTreatmentPerformRecordUX-div-113"
                  style={{width: "100%"}}>
                  {props.startTime}
                </div>
              </FormField>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-105">
                <label
                  id="CardRehabTreatmentPerformRecordUX-label-109">
                  {props.languageUX === "en" ? "End date/time :" : "วันที่/เวลาสิ้นสุด :"}
                </label>
              </FormField>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-106">
                <div
                  id="CardRehabTreatmentPerformRecordUX-div-111"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardRehabTreatmentPerformRecordUX-DateTextBox-114"
                    onChange={props.onChangeDate?.("endDate")}
                    value={props.data?.endDate}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-107"
                width={2}>
                <div
                  id="CardRehabTreatmentPerformRecordUX-div-115"
                  style={{width: "100%"}}>
                  {props.endTime}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardRehabTreatmentPerformRecordUX-FormGroup-100"
              inline={true}>
              <FormField
                id="CardRehabTreatmentPerformRecordUX-FormField-102"
                style={{padding:0}}
                width={16}>
                <TextArea
                  id="CardRehabTreatmentPerformRecordUX-TextArea-116"
                  name="result"
                  onChange={props.onChangeValue}
                  rows={5}
                  value={props.data?.result ?? ""}>
                </TextArea>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-25"
            style={{fontWeight:"bold",fontSize:"1.15rem",margin:"10px 0px",textDecoration:"underline"}}>
            {props.languageUX === "en" ? "Post-Treatment Evaluation" : "การประเมินหลังการรักษา"}
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-26">
            
            <TextArea
              id="CardRehabTreatmentPerformRecordUX-TextArea-55"
              name="post_treatment_evaluation"
              onChange={props.onChangeValue}
              value={props.data?.post_treatment_evaluation?? ""}>
            </TextArea>
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-27"
            style={{fontWeight:"bold",fontSize:"1.15rem",margin:"10px 0px",textDecoration:"underline"}}>
            {props.languageUX === "en" ? "Recommendation & Patient Education" : "คำแนะนำและการศึกษาสำหรับผู้ป่วย"}
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-28">
            
            <TextArea
              id="CardRehabTreatmentPerformRecordUX-TextArea-56"
              name="recommendation_education"
              onChange={props.onChangeValue}
              value={props.data?.recommendation_education?? ""}>
            </TextArea>
          </div>
          <div
            id="CardRehabTreatmentPerformRecordUX-div-29"
            style={{display:"flex",justifyContent:"flex-end",gap:"20px",margin:"20px 0px"}}>
            
            <div
              id="CardRehabTreatmentPerformRecordUX-div-57"
              style={{ display: props.isPerformed ? "none" : "flex", alignItems:"center",gap:"10px"}}>
              
              <div
                id="CardRehabTreatmentPerformRecordUX-div-60"
                style={{fontWeight:"bold"}}>
                Perform by: 
              </div>
              <div
                id="CardRehabTreatmentPerformRecordUX-div-118">
                {props.employeeToken}
              </div>
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-57"
              style={{ display: props.isPerformed ? "flex" : "none", alignItems:"center",gap:"10px"}}>
              
              <label
                id="CardRehabTreatmentPerformRecordUX-label-125"
                style={{ fontWeight: "bold" }}>
                Edit reason
              </label>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-126"
                style={{ color: "red" }}>
                *
              </label>
              <Input
                id="CardRehabTreatmentPerformRecordUX-Input-127"
                name="edit_perform_note"
                onChange={props.onChangeValue}
                type="text"
                value={props.data?.edit_perform_note?? ""}>
              </Input>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-128"
                style={{ fontWeight: "bold" }}>
                Edited by
              </label>
              <label
                id="CardRehabTreatmentPerformRecordUX-label-129"
                style={{ color: "red" }}>
                *
              </label>
              <div
                id="CardRehabTreatmentPerformRecordUX-div-118">
                {props.employeeToken}
              </div>
            </div>
            <div
              id="CardRehabTreatmentPerformRecordUX-div-117">
              {props.buttonSave}
            </div>
          </div>
        </Form>
      </div>
    )
}


export default CardRehabTreatmentPerformRecordUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Wed Sep 03 2025 12:06:47 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent:\"space-between\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "code",
          "value": "props.data? \"\":\"hidden\""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-Form-15"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสขั้นตอน",
          "valueEN": "Procedure code"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{fontSize:\"1.15rem\",fontWeight:\"bold\",textDecoration:\"underline\",margin:\"10px 0px 5px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการรักษา",
          "valueEN": "Treatment Details"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\",fontSize: \"1.15rem\",margin:\"10px 0px\",textDecoration:\"underline\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-23"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมินหลังการรักษา",
          "valueEN": "Post-Treatment Evaluation"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\",fontSize:\"1.15rem\",margin:\"10px 0px\",textDecoration:\"underline\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-26"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำและการศึกษาสำหรับผู้ป่วย",
          "valueEN": "Recommendation & Patient Education"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\",fontSize:\"1.15rem\",margin:\"10px 0px\",textDecoration:\"underline\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-28"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\",gap:\"20px\",margin:\"20px 0px\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",alignItems:\"center\", marginLeft: \"1.25rem\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{display:props.data?.procedure?.secondary?.length === 0 ? \"none\":\"flex\", marginLeft: \"1.25rem\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "Principle procedure: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{width:\"160px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "Secondary procedure: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{width:\"160px\", marginTop: \"7px\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddSecondary"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-48"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "TextArea",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-55"
        },
        "name": {
          "type": "value",
          "value": "post_treatment_evaluation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.post_treatment_evaluation?? \"\""
        }
      },
      "seq": 55,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "TextArea",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-56"
        },
        "name": {
          "type": "value",
          "value": "recommendation_education"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.recommendation_education?? \"\""
        }
      },
      "seq": 56,
      "void": true
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isPerformed ? \"none\" : \"flex\", alignItems:\"center\",gap:\"10px\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "Perform by: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"2rem 0 1rem\", display: props.data? \"\":\"none\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"2rem\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การตรวจสอบ",
          "valueEN": "Examination"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.15rem\",fontWeight:\"bold\",textDecoration:\"underline\",margin:\"6px 0px\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Button",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "purple"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-Button-69"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenScanDocument"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Button",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-Button-70"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenViewDocument"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", position: \"relative\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-71"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "การรักษาที่ดำเนินการในวันนี้",
          "valueEN": "Treatment Performed today"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"1rem 0.25rem 0.5rem 0.25rem\", fontSize: \"1.15rem\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "img",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-img-75"
        },
        "src": {
          "type": "value",
          "value": "/static/images/rehab/scanning-document.png"
        },
        "style": {
          "type": "code",
          "value": "{width: \"16px\"}"
        }
      },
      "seq": 75,
      "void": true
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "การสแกนเอกสาร",
          "valueEN": "Scanning Document"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-76"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "img",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-img-77"
        },
        "src": {
          "type": "value",
          "value": "/static/images/rehab/view-document.png"
        },
        "style": {
          "type": "code",
          "value": "{width: \"21px\", position: \"absolute\", \"left\": \"8px\", marginTop: \"5px\"}"
        }
      },
      "seq": 77,
      "void": true
    },
    {
      "from": null,
      "id": 78,
      "name": "label",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "ดูเอกสาร สแกน",
          "valueEN": "View Document Scan"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-78"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"22px\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormGroup",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-79"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormGroup",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-80"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormGroup",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-81"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormGroup",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormGroup",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 79,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"flex-start\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"flex-start\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"flex-start\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 83,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems: \"flex-start\"}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "Goal: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-88"
        },
        "style": {
          "type": "code",
          "value": "{width: \"85px\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "Assessment: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-89"
        },
        "style": {
          "type": "code",
          "value": "{width: \"85px\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "Objective: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{width: \"85px\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "Subjective: "
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-91"
        },
        "style": {
          "type": "code",
          "value": "{width: \"85px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "TextArea",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-92"
        },
        "name": {
          "type": "value",
          "value": "goal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.goal?? \"\""
        }
      },
      "seq": 92,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "TextArea",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-93"
        },
        "name": {
          "type": "value",
          "value": "assessment"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.assessment?? \"\""
        }
      },
      "seq": 93,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "TextArea",
      "parent": 85,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-94"
        },
        "name": {
          "type": "value",
          "value": "objective"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.objective?? \"\""
        }
      },
      "seq": 94,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "TextArea",
      "parent": 84,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-95"
        },
        "name": {
          "type": "value",
          "value": "subjective"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.data?.subjective ?? \"\""
        }
      },
      "seq": 95,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-96"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "การสอบอื่นๆ :",
          "valueEN": "Other Examination :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "TextArea",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-98"
        },
        "name": {
          "type": "value",
          "value": "other_examination"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "code",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.data?.other_examination?? \"\""
        }
      },
      "seq": 98,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormGroup",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-99"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormGroup",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormGroup-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-101"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-103"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-104"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-105"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-106"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-FormField-107"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่/เวลาเริ่มต้น :",
          "valueEN": "Start date/time :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-108"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่/เวลาสิ้นสุด :",
          "valueEN": "End date/time :"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 112,
      "name": "DateTextBox",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-DateTextBox-112"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.data?.startDate"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "code",
          "value": "props.startTime"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-113"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 114,
      "name": "DateTextBox",
      "parent": 111,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-DateTextBox-114"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.data?.endDate"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 107,
      "props": {
        "children": {
          "type": "code",
          "value": "props.endTime"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "TextArea",
      "parent": 102,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-TextArea-116"
        },
        "name": {
          "type": "value",
          "value": "result"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "rows": {
          "type": "code",
          "value": "5"
        },
        "value": {
          "type": "code",
          "value": "props.data?.result ?? \"\""
        }
      },
      "seq": 116,
      "void": true
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-117"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeToken"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-118"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "code",
          "value": "props.treatmentPerform"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "code",
          "value": "props.principalProcedure"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.secondaryProcedure"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-121"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.isPerformed ? \"flex\" : \"none\", alignItems:\"center\",gap:\"10px\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 122,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeToken"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-118"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "Edit reason"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-125"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-126"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "Input",
      "parent": 122,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-Input-127"
        },
        "name": {
          "type": "value",
          "value": "edit_perform_note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "type": {
          "type": "value",
          "value": "text"
        },
        "value": {
          "type": "code",
          "value": "props.data?.edit_perform_note?? \"\""
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "Edited by"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" }"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ดำเนินการรักษา",
          "valueEN": "Treatment Perform date"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"6px\", marginRight: \"12px\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.performStartDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"12px\", marginRight: \"12px\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.performEndDateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-134"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-div-135"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"12px\", marginRight: \"12px\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Checkbox",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isIncludePerformed"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentPerformRecordUX-Checkbox-136"
        },
        "label": {
          "type": "value",
          "value": "รวมที่ดำเนินการแล้ว",
          "valueEN": "Include Performed"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeIncludePerformedRecord"
        }
      },
      "seq": 136,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardRehabTreatmentPerformRecordUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
